export class ApiClientError extends Error {
  constructor(message, { status, details } = {}) {
    super(message);
    this.name = "ApiClientError";
    this.status = status;
    this.details = details;
  }
}

const parseResponseBody = async (response) => {
  if (response.status === 204) {
    return null;
  }

  const contentType = response.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    try {
      return await response.json();
    } catch (error) {
      if (!response.ok) {
        return null;
      }

      throw new ApiClientError("Unable to parse JSON response.", {
        status: response.status,
      });
    }
  }

  const text = await response.text();
  return text || null;
};

export const requestJson = async (url, { method = "GET", headers = {}, body } = {}) => {
  const response = await fetch(url, {
    method,
    headers: {
      Accept: "application/json",
      ...headers,
    },
    body,
  });

  const payload = await parseResponseBody(response);

  if (!response.ok) {
    const message =
      payload?.message || payload?.error || `Request failed with status ${response.status}`;

    throw new ApiClientError(message, {
      status: response.status,
      details: payload,
    });
  }

  return payload;
};

export const postJson = (url, data, options = {}) =>
  requestJson(url, {
    ...options,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    body: JSON.stringify(data),
  });
